import { SELECTED_FLEET_CHANGED } from '../actions/retorno-veiculo.actions'

const initialRetornoState = {
  selectedFeet: null,
}

export default function (state = initialRetornoState, action) {
  switch (action.type) {
    case SELECTED_FLEET_CHANGED:
      return {
        ...state,
        selectedFeet: action.fleet,
      }
    default:
      return state
  }
}
